import React, { useEffect, useMemo } from "react";
import { useProcessingShipments } from "../../../features/supplier-fulfillment/hooks/useProcessingShipments";
import { useSupplierProcessingStore } from "../../../store/useSupplierProcessingStore.ts";
import ShipmentCard from "./ShipmentCard";
import Pagination from "../../Pagination";

const ShipmentTable = () => {
  const warehouse = useSupplierProcessingStore((s) => s.warehouse);
  const search = useSupplierProcessingStore((s) => s.search);
  const ordering = useSupplierProcessingStore((s) => s.ordering);
  const status = useSupplierProcessingStore((s) => s.status);
  const isPinned = useSupplierProcessingStore((s) => s.isPinned);

  const currentPage = useSupplierProcessingStore((s) => s.currentPage);
  const pageSize = useSupplierProcessingStore((s) => s.pageSize);
  const totalCount = useSupplierProcessingStore((s) => s.totalCount);

  const setCurrentPage = useSupplierProcessingStore((s) => s.setCurrentPage);
  const setTotalCount = useSupplierProcessingStore((s) => s.setTotalCount);

  const queryFilters = useMemo(
    () => ({
      warehouse,
      search,
      ordering,
      status,
      isPinned,
      currentPage,
      pageSize,
    }),
    [warehouse, search, ordering, status,isPinned, currentPage, pageSize]
  );

  const { data, isLoading, isFetching, isError, error } =
    useProcessingShipments(queryFilters);

  const shipments = useMemo(() => {
    return data?.results || (Array.isArray(data) ? data : []);
  }, [data]);

  useEffect(() => {
    const nextTotalCount =
      typeof data?.count === "number"
        ? data.count
        : Array.isArray(data)
          ? data.length
          : 0;

    if (nextTotalCount !== totalCount) {
      setTotalCount(nextTotalCount);
    }
  }, [data, totalCount, setTotalCount]);

  const totalPages = totalCount > 0 ? Math.ceil(totalCount / pageSize) : 0;

  if (!warehouse) {
    return (
      <div className="rounded-lg border border-dashed border-gray-300 bg-gray-50 p-6 text-center text-sm text-gray-500">
        لطفاً ابتدا یک انبار انتخاب کنید.
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="rounded-lg bg-white p-6 text-center text-sm text-gray-500 shadow-sm">
        در حال دریافت لیست محموله‌ها...
      </div>
    );
  }

  if (isError) {
    return (
      <div className="rounded-lg bg-red-50 p-6 text-center text-sm text-red-600">
        خطا در دریافت لیست محموله‌ها
        {error?.message ? `: ${error.message}` : ""}
      </div>
    );
  }

  return (
    <div>
      {isFetching && !isLoading && (
        <div className="mb-3 rounded-lg bg-blue-50 px-4 py-2 text-sm text-blue-600">
          در حال بروزرسانی لیست محموله‌ها...
        </div>
      )}

      {shipments.length === 0 ? (
        <div className="rounded-lg border border-dashed border-gray-300 bg-gray-50 p-6 text-center text-sm text-gray-500">
          هیچ محموله‌ای برای این انبار یافت نشد.
        </div>
      ) : (
        <div className="space-y-4">
          {shipments.map((shipment) => (
            <ShipmentCard key={shipment.id} shipment={shipment} />
          ))}
        </div>
      )}


      <div className="mt-8">
        <Pagination
          page={currentPage}
          setPage={setCurrentPage}
          totalPages={totalPages}
        />
      </div>

    </div>
  );
};

export default ShipmentTable;
